import { BoardNavSubItem } from './BoardNavSubItem';

type BoardNavItemProps = {
  board: any;
};

export const BoardNavItem = ({ board }: BoardNavItemProps) => {
  return (
    <>
      <BoardNavSubItem
        key={board._id}
        depth={0}
        type="board"
        item={board}
        boardId={board._id}
      />
    </>
  );
};
